<template>
  <div class="diseaseList">
    <!-- 自定义 Tab 切换 -->
    <div class="custom-tabs">
      <div class="tab-header">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'cardList' }"
          @click="switchTab('cardList')"
        >
          <span>卡券列表</span>
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'templateManage' }"
          @click="switchTab('templateManage')"
        >
          <span>领取卡券模版维护</span>
        </div>
      </div>

      <!-- 卡券列表内容 -->
      <div class="tab-content" v-show="activeTab === 'cardList'">
        <!-- 筛选查询框 -->
        <el-form :inline="true" size="mini" style="margin: 10px auto">
          <el-form-item label="卡券名称: " style="margin-left: 20px">
            <el-input
              v-model="listQuery.couponTitle"
              placeholder="请输入"
              style="width: 180px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="卡号: " style="margin-left: 20px">
            <el-input
              v-model="listQuery.cardNumber"
              placeholder="请输入"
              style="width: 180px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="卡密: " style="margin-left: 20px">
            <el-input v-model="listQuery.password" placeholder="请输入" style="width: 180px" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号: " style="margin-left: 20px">
            <el-input
              v-model="listQuery.userPhone"
              placeholder="请输入"
              style="width: 180px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态: " style="margin: 0 20px">
            <el-select
              style="width: 180px"
              v-model="listQuery.cardStatus"
              placeholder="请选择"
              clearable
            >
              <div v-for="(item, index) in cardStatusList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getListData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAdd">创建卡券</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="danger"
              :disabled="multipleSelection.length === 0"
              @click="handleBatchDelete"
            >批量删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="downloadLoading"
              style="margin: 0 0 10px 0px"
              type="primary"
              icon="el-icon-document"
              @click="handleDownload"
            >导出数据 Excel（ {{ tableData.length }} ）</el-button>
          </el-form-item>
        </el-form>

        <!-- 商品表格 -->
        <ElTable
          height="calc(100vh - 340px)"
          :columns="listHeader"
          :tableData="tableData"
          :loading="loading"
          :total="listQuery.total"
          @selection-change="handleSelectionChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template slot="exchange_type" slot-scope="{ row }">
            <el-tag v-if="row.exchange_type === 1" type="success" effect="dark" size="mini">满减券</el-tag>
            <el-tag v-if="row.exchange_type === 2" effect="info" size="mini">商品券</el-tag>
            <el-tag v-if="row.exchange_type === 3" type="danger" effect="dark" size="mini">购物金</el-tag>
          </template>

          <template slot="source" slot-scope="{ row }">
            <el-tag v-if="row.source === 1" effect="success" size="mini">平台创建</el-tag>
            <el-tag v-if="row.source === 2" size="mini">用户通过模版领取</el-tag>
            <el-tag v-if="row.source === 3" type="danger" effect="dark" size="mini">积分兑换</el-tag>
          </template>

          <template
            slot="writeOffTime"
            slot-scope="{ row }"
          >{{ row.writeOffTime?row.writeOffTime:'-' }}</template>
          <template
            slot="exchangeTime"
            slot-scope="{ row }"
          >{{ row.exchangeTime?row.exchangeTime:'-' }}</template>
          <template slot="userPhone" slot-scope="{ row }">{{ row.userPhone?row.userPhone:'-' }}</template>
          <template slot="cardStatus" slot-scope="{ row }">
            <el-tag v-if="row.cardStatus === 0" effect="dark" size="mini">待领取</el-tag>
            <el-tag v-else-if="row.cardStatus === 1" effect="dark" size="mini" type="danger">未核销</el-tag>
            <el-tag v-else type="success" effect="dark" size="mini">已核销</el-tag>
          </template>
          <template slot="operation" slot-scope="{ row }">
            <div class="operation">
              <!-- 详情 -->
              <el-button size="mini" type="text" @click="handleDetails(row)">详情</el-button>
              <el-button
                size="mini"
                type="text"
                style="color: rgb(255, 0, 0);"
                @click="handleDelete(row)"
              >删除</el-button>
            </div>
          </template>
        </ElTable>

        <!-- 批量生成卡券弹窗 -->
        <el-dialog title="批量生成卡券" :visible.sync="couponVisible">
          <div style="margin: 20px; color: red">
            生成规则:
            XXXX(前位字符自己输入)+XXXX(设置一个数字起点,按数递增)
          </div>
          <el-form :model="dialogFormVisible" :label-width="formLabelWidth">
            <el-form-item label="卡号前字符" required>
              <el-input
                v-model="dialogForm.firstVipNumber"
                auto-complete="off"
                placeholder="通常为合作商字母或数字标识"
              ></el-input>
            </el-form-item>
            <el-form-item label="后四位起点" required>
              <el-input
                v-model="dialogForm.lastVipNumber"
                auto-complete="off"
                placeholder="通常为序号标识,写入生成的起点数字(4位数以内)"
                maxlength="4"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="卡券名称" required>
              <el-input v-model="dialogForm.couponTitle" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="卡券规格描述" required>
              <el-input v-model="dialogForm.msg" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="兑换类型" required>
              <el-radio-group v-model="dialogForm.exchange_type">
                <el-radio :label="1">满减券</el-radio>
                <!-- <el-radio :label="2">商品券</el-radio> -->
                <el-radio :label="3">省钱卡购物金</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="卡券金额"
              required
              v-if="dialogForm.exchange_type === 1 ||dialogForm.exchange_type === 3"
            >
              <el-input v-model.number="dialogForm.price" auto-complete="off" type="number"></el-input>
            </el-form-item>

            <el-form-item label="使用门槛" required v-if="dialogForm.exchange_type === 1">
              <el-input v-model.number="dialogForm.maxPrice" auto-complete="off" type="number"></el-input>
            </el-form-item>

            <el-form-item label="选择商品" required v-if="dialogForm.exchange_type === 2">
              <el-button
                size="small"
                type="primary"
                @click="showProductSelector"
              >{{ selectedProduct ? selectedProduct.productName : '点击选择商品' }}</el-button>
              <span
                v-if="selectedProduct"
                style="margin-left: 10px; color: #67C23A;"
              >已选择: {{ selectedProduct.productName }}</span>
            </el-form-item>

            <el-form-item label="生成数量" required>
              <el-input
                placeholder="单次数量小于1000"
                v-model.number="dialogForm.num"
                auto-complete="off"
                type="number"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="couponVisible = false">取消</el-button>
            <el-button type="primary" @click="save">确定</el-button>
          </div>
        </el-dialog>

        <!-- 商品选择对话框 -->
        <el-dialog title="选择商品" :visible.sync="productSelectorVisible" width="80%">
          <el-form :inline="true" size="mini">
            <el-form-item label="商品名称: ">
              <el-input v-model="productQuery.productName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品编码: ">
              <el-input v-model="productQuery.productCode" placeholder="请输入商品编码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getProductList">搜索</el-button>
            </el-form-item>
          </el-form>

          <ElTable
            :columns="productListHeader"
            :tableData="productTableData"
            :loading="productLoading"
            :total="productQuery.total"
            :listQuery="productQuery"
            @handleCurrentChange="handleProductCurrentChange"
            @handleSizeChange="handleProductSizeChange"
          >
            <template slot="img" slot-scope="{ row }">
              <img :src="row.coverImg" alt style="width: 60px; height: 60px; object-fit: cover;" />
            </template>
            <!-- <template slot="status" slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type="success" size="mini">上架</el-tag>
          <el-tag v-else type="info" size="mini">下架</el-tag>
            </template>-->
            <template slot="operation" slot-scope="{ row }">
              <el-button size="mini" type="primary" @click="handleProductSelect(row)">选择</el-button>
            </template>
          </ElTable>

          <div slot="footer" class="dialog-footer">
            <el-button @click="productSelectorVisible = false">取消</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 领取卡券模版维护内容 -->
      <div class="tab-content" v-show="activeTab === 'templateManage'">
        <!-- 筛选查询框 -->
        <el-form :inline="true" size="mini" style="margin: 10px auto">
          <el-form-item label="卡券名称: " style="margin-left: 20px">
            <el-input
              v-model="templateQuery.couponTitle"
              placeholder="请输入"
              style="width: 180px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态: " style="margin: 0 20px">
            <el-select
              style="width: 180px"
              v-model="templateQuery.status"
              placeholder="请选择"
              clearable
            >
              <el-option label="关闭领取" :value="0"></el-option>
              <el-option label="开启领取" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getTemplateList">搜索</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="handleAddTemplate">新增模版</el-button>
          </el-form-item>-->
        </el-form>

        <!-- 模版表格 -->
        <ElTable
          height="calc(100vh - 280px)"
          :columns="templateListHeader"
          :tableData="templateTableData"
          :loading="templateLoading"
          :total="templateQuery.total"
          @handleCurrentChange="handleTemplateCurrentChange"
          @handleSizeChange="handleTemplateSizeChange"
        >
          <template slot="status" slot-scope="{ row }">
            <el-tag v-if="row.status === 1" type="success" effect="dark" size="mini">开启领取</el-tag>
            <el-tag v-else type="info" effect="dark" size="mini">关闭领取</el-tag>
          </template>
          <template slot="product_id" slot-scope="{ row }">
            <div v-if="row.product_id && row.productNames">
              <el-tag
                v-for="(name, idx) in row.productNames.split(',')"
                :key="idx"
                type="primary"
                size="mini"
                style="margin: 2px;"
              >{{ name }}</el-tag>
            </div>
            <el-tag
              v-else-if="row.product_id"
              type="warning"
              size="mini"
            >已绑定({{ row.product_id.split(',').length }}个)</el-tag>
            <el-tag v-else type="info" size="mini">未绑定</el-tag>
          </template>
          <template slot="operation" slot-scope="{ row }">
            <div class="operation">
              <el-button size="mini" type="text" @click="handleEditTemplate(row)">编辑</el-button>
              <el-button
                size="mini"
                type="text"
                style="color: rgb(255, 0, 0);"
                @click="handleDeleteTemplate(row)"
                v-if="row.id!==1"
              >删除</el-button>
            </div>
          </template>
        </ElTable>

        <!-- 模版编辑对话框 -->
        <el-dialog :title="templateDialogTitle" :visible.sync="templateDialogVisible" width="600px">
          <el-form :model="templateForm" :label-width="formLabelWidth">
            <el-form-item label="卡券名称" required>
              <el-input v-model="templateForm.couponTitle" placeholder="请输入卡券名称"></el-input>
            </el-form-item>
            <el-form-item label="描述" required>
              <el-input v-model="templateForm.msg" type="textarea" placeholder="请输入描述"></el-input>
            </el-form-item>
            <el-form-item label="优惠券价格" required>
              <el-input-number v-model="templateForm.price" :min="0" placeholder="请输入价格"></el-input-number>
            </el-form-item>
            <el-form-item label="满多少可用" required>
              <el-input-number v-model="templateForm.maxPrice" :min="0" placeholder="请输入使用门槛"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="有效期(天)" required>
              <el-input v-model="templateForm.validTime" placeholder="例如: 30天"></el-input>
            </el-form-item>-->
            <el-form-item label="状态" required>
              <el-radio-group v-model="templateForm.status">
                <el-radio :label="0">关闭领取通道</el-radio>
                <el-radio :label="1">开启领取通道</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="绑定商品">
              <el-button
                size="small"
                type="primary"
                @click="showTemplateProductSelector"
              >{{ selectedTemplateProducts.length > 0 ? '已选择 ' + selectedTemplateProducts.length + ' 个商品' : '点击选择商品' }}</el-button>
              <div v-if="selectedTemplateProducts.length > 0" style="margin-top: 10px;">
                <el-tag
                  v-for="product in selectedTemplateProducts"
                  :key="product.id"
                  closable
                  @close="handleRemoveTemplateProduct(product.id)"
                  style="margin-right: 5px; margin-bottom: 5px;"
                >{{ product.productName }}</el-tag>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="templateDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveTemplate">确定</el-button>
          </div>
        </el-dialog>

        <!-- 模版商品选择对话框 -->
        <el-dialog title="选择商品" :visible.sync="templateProductSelectorVisible" width="80%">
          <el-form :inline="true" size="mini">
            <el-form-item label="商品名称: ">
              <el-input v-model="templateProductQuery.productName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getTemplateProductList">搜索</el-button>
            </el-form-item>
          </el-form>

          <ElTable
            :columns="templateProductListHeader"
            :tableData="templateProductTableData"
            :loading="templateProductLoading"
            :total="templateProductQuery.total"
            :listQuery="templateProductQuery"
            @handleCurrentChange="handleTemplateProductCurrentChange"
            @handleSizeChange="handleTemplateProductSizeChange"
          >
            <template slot="img" slot-scope="{ row }">
              <img :src="row.coverImg" alt style="width: 60px; height: 60px; object-fit: cover;" />
            </template>
            <template slot="operation" slot-scope="{ row }">
              <el-button
                size="mini"
                :type="isProductSelected(row.id) ? 'success' : 'primary'"
                @click="handleTemplateProductSelect(row)"
              >{{ isProductSelected(row.id) ? '已选择' : '选择' }}</el-button>
            </template>
          </ElTable>

          <div slot="footer" class="dialog-footer">
            <el-button @click="templateProductSelectorVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 卡券详情弹窗 -->
    <el-dialog title="卡券详情" :visible.sync="detailsDialogVisible" width="600px">
      <el-form :model="detailsData" label-width="120px" size="small">
        <el-form-item label="卡券名称:">
          <span>{{ detailsData.couponTitle || '-' }}</span>
        </el-form-item>
        <el-form-item label="规格描述:">
          <span>{{ detailsData.msg || '-' }}</span>
        </el-form-item>
        <el-form-item label="兑换类型:">
          <el-tag
            v-if="detailsData.exchange_type === 1"
            type="success"
            effect="dark"
            size="mini"
          >满减券</el-tag>
          <el-tag v-else-if="detailsData.exchange_type === 2" effect="info" size="mini">商品券</el-tag>
          <el-tag
            v-else-if="detailsData.exchange_type === 3"
            type="danger"
            effect="dark"
            size="mini"
          >购物金</el-tag>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="卡号:">
          <span>{{ detailsData.cardNumber || '-' }}</span>
        </el-form-item>
        <el-form-item label="卡密:">
          <span>{{ detailsData.password || '-' }}</span>
        </el-form-item>
        <el-form-item
          label="价格:"
          v-if="detailsData.exchange_type === 1 || detailsData.exchange_type === 3"
        >
          <span>{{ detailsData.price ? '¥' + detailsData.price : '-' }}</span>
        </el-form-item>
        <el-form-item label="使用门槛:" v-if="detailsData.exchange_type === 1">
          <span>{{ detailsData.maxPrice ? '满¥' + detailsData.maxPrice + '可用' : '-' }}</span>
        </el-form-item>
        <el-form-item label="关联商品:">
          <div v-if="detailsProductNames.length > 0">
            <el-tag
              v-for="product in detailsProductNames"
              :key="product.id"
              type="primary"
              size="mini"
              style="margin-right: 5px; margin-bottom: 5px;"
            >{{ product.name }}</el-tag>
          </div>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="卡券状态:">
          <el-tag v-if="detailsData.cardStatus === 0" effect="dark" size="mini">待领取</el-tag>
          <el-tag
            v-else-if="detailsData.cardStatus === 1"
            effect="dark"
            size="mini"
            type="danger"
          >未核销</el-tag>
          <el-tag
            v-else-if="detailsData.cardStatus === 2"
            type="success"
            effect="dark"
            size="mini"
          >已核销</el-tag>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="领取人手机号:" v-if="detailsData.userPhone">
          <span>{{ detailsData.userPhone }}</span>
        </el-form-item>
        <el-form-item label="兑换时间:" v-if="detailsData.exchangeTime">
          <span>{{ detailsData.exchangeTime }}</span>
        </el-form-item>
        <el-form-item label="核销时间:" v-if="detailsData.writeOffTime">
          <span>{{ detailsData.writeOffTime }}</span>
        </el-form-item>
        <el-form-item label="创建时间:">
          <span>{{ detailsData.createTime || '-' }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailsDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import {
  selectApi,
  deleteApi,
  addListApi,
  selectTemplateApi,
  addTemplateApi,
  updateTemplateApi,
  deleteTemplateApi
} from "@/services/coupon/index.js";
import { selectGoods } from "@/services/mall/goods.js";

import XLSX from "xlsx";
import { mapState } from "vuex";
export default {
  components: {
    ElTable
  },

  async created() {
    this.getListData();
  },

  data() {
    return {
      // Tab 相关
      activeTab: "cardList",
      role_id: "",
      sum1: "",
      sum2: "",
      totalCount: 0,
      downloadLoading: false,
      dialogForm: {}, //新增卡券参数
      status: 0,
      goodsTitle: "",
      listQuery: {
        // type: 2, // 1优惠券 2卡券
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      tableData: [],

      cardStatusList: [
        { id: 0, name: "未领取" },
        { id: 1, name: "未核销" },
        { id: 2, name: "已核销" }
      ],
      dialogFormVisible: false,
      dialogFormVisible: {},
      formLabelWidth: "120px",

      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      couponVisible: false,
      multipleSelection: [],

      // 商品选择相关
      productSelectorVisible: false,
      selectedProduct: null,
      productQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: "",
        productCode: ""
      },
      productTableData: [],
      productLoading: false,

      // 模版管理相关
      templateQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        couponTitle: "",
        status: null
      },
      templateTableData: [],
      templateLoading: false,
      templateDialogVisible: false,
      templateDialogTitle: "新增模版",
      templateForm: {},
      selectedTemplateProducts: [],
      templateProductSelectorVisible: false,
      templateProductQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: ""
      },
      templateProductTableData: [],
      templateProductLoading: false,

      // 详情弹窗相关
      detailsDialogVisible: false,
      detailsData: {},
      detailsProductNames: []
    };
  },

  computed: {
    listHeader,
    // 商品列表表头
    productListHeader() {
      return [
        { label: "序号", type: "index", width: 60 },
        { label: "商品图片", prop: "coverImg", width: 100, slots: "img" },
        { label: "商品名称", prop: "productName", minWidth: 200 },
        { label: "商品编码", prop: "productCode", width: 150 },
        { label: "价格", prop: "price", width: 100 },
        // { label: "状态", prop: "status", width: 100, slots: "status" },
        {
          label: "操作",
          prop: "operation",
          width: 100,
          slots: "operation",
          fixed: "right"
        }
      ];
    },
    // 模版列表表头
    templateListHeader() {
      return [
        { label: "序号", type: "index", width: 60 },
        { label: "卡券名称", prop: "couponTitle", minWidth: 150 },
        { label: "描述", prop: "msg", minWidth: 200 },
        { label: "优惠券价格", prop: "price", width: 100 },
        { label: "满多少可用", prop: "maxPrice", width: 100 },
        // { label: "有效期", prop: "validTime", width: 100 },
        { label: "状态", prop: "status", width: 100, slots: "status" },
        {
          label: "绑定商品",
          prop: "product_id",
          width: 100,
          slots: "product_id"
        },
        {
          label: "操作",
          prop: "operation",
          width: 150,
          slots: "operation",
          fixed: "right"
        }
      ];
    },
    // 模版商品列表表头
    templateProductListHeader() {
      return [
        { label: "序号", type: "index", width: 60 },
        { label: "商品图片", prop: "coverImg", width: 100, slots: "img" },
        { label: "商品名称", prop: "productName", minWidth: 200 },
        { label: "价格", prop: "price", width: 100 },
        {
          label: "操作",
          prop: "operation",
          width: 100,
          slots: "operation",
          fixed: "right"
        }
      ];
    },
    ...mapState(["userInfo", "filterStoreList"])
  },

  methods: {
    // 多选变化
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    // 批量删除
    async handleBatchDelete() {
      if (!this.multipleSelection.length) {
        return this.$message.warning("请先选择要删除的卡券");
      }
      try {
        await this.$confirm(
          `此操作将删除选中的 ${this.multipleSelection.length} 条记录，是否继续？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
      } catch (e) {
        return; // 取消
      }

      const ids = this.multipleSelection.map(i => i.id).filter(Boolean);
      if (!ids.length) return;

      this.loading = true;
      try {
        // 逐个删除:
        // await Promise.all(ids.map(id => deleteApi({ id })));
        //批量删除
        let result = await deleteApi({ id: ids });
        if (result.code === 200) {
          this.$message.success("批量删除成功");
          this.getListData();
          this.multipleSelection = [];
        } else {
          this.$message.error("部分或全部删除失败，请重试");
        }
      } catch (err) {
        this.$message.error("部分或全部删除失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectApi({
        ...listQuery
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      if (this.listQuery.total >= 50000) {
        return this.$message.error("当前卡券数据已达上限");
      }
      this.couponVisible = true;
      this.dialogForm = {
        exchange_type: 1 // 默认选择满减券
      };
      this.selectedProduct = null;
    },

    /* 编辑 */
    handleUpdate() {
      updateCardCoupon(this.form).then(resp => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.getListData();
        }
      });
    },

    /* 显示商品选择器 */
    showProductSelector() {
      this.productSelectorVisible = true;
      this.productQuery = {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: "",
        productCode: ""
      };
      this.getProductList();
    },

    /* 获取商品列表 */
    async getProductList() {
      this.productLoading = true;
      try {
        const { data, code, count } = await selectGoods({
          pageNumber: this.productQuery.pageNumber,
          pageSize: this.productQuery.pageSize,
          productName: this.productQuery.productName,
          productCode: this.productQuery.productCode,
          type: 2 // 只查询商品类型为2的商品
        });
        if (code === 200) {
          this.productTableData = data;
          this.productQuery.total = count;
        }
      } catch (err) {
        console.error(err);
        this.$message.error("获取商品列表失败");
      } finally {
        this.productLoading = false;
      }
    },

    /* 商品选择 */
    handleProductSelect(row) {
      this.selectedProduct = row;
      this.dialogForm.product_id = row.id;
      this.productSelectorVisible = false;
      this.$message.success(`已选择商品: ${row.productName}`);
    },

    /* 商品列表分页 */
    handleProductCurrentChange(e) {
      this.productQuery.pageNumber = e;
      this.getProductList();
    },

    handleProductSizeChange(e) {
      this.productQuery.pageSize = e;
      this.getProductList();
    },

    /* 保存 */
    save() {
      if (!this.dialogForm.couponTitle) {
        this.$message.error("请填写卡券名称");
        return;
      }
      if (!this.dialogForm.msg) {
        this.$message.error("请填写卡券规格描述");
        return;
      }

      // 验证兑换类型
      if (!this.dialogForm.exchange_type) {
        this.$message.error("请选择兑换类型");
        return;
      }

      // 如果是商品券，验证是否选择了商品
      if (this.dialogForm.exchange_type === 2) {
        if (!this.dialogForm.product_id) {
          this.$message.error("请选择商品");
          return;
        }
      }

      if (this.dialogForm.exchange_type === 1) {
        if (!this.dialogForm.price) {
          this.$message.error("请填写优惠券价格");
          return;
        }
        if (!this.dialogForm.maxPrice && this.dialogForm.maxPrice !== 0) {
          this.$message.error("请填写满多少可用");
          return;
        }
      }

      if (
        !this.dialogForm.lastVipNumber ||
        this.dialogForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }

      if (!this.dialogForm.firstVipNumber) {
        return this.$message.error("卡号前位字符");
      }
      if (
        !this.dialogForm.lastVipNumber ||
        this.dialogForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }
      if (!this.dialogForm.num || this.dialogForm.num > 1000) {
        this.$message.error("请输入合法的数量");
        return;
      }
      this.loading = true;
      //生成卡号与卡密
      addListApi({
        ...this.dialogForm,
        type: 2, // 1优惠券 2卡券
        cardStatus: 0,
        source: 1 //来源
      })
        .then(resp => {
          if (resp.code === 200) {
            this.$message.success("新增成功");
            this.getListData();
            this.couponVisible = false;
            this.selectedProduct = null;
          } else {
            this.$message.error(resp.message || "新增失败，请重试");
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该卡券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    // 导出数据wangsheng_admin/src/vendor
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "卡券名称",
          "卡券规格描述",
          "卡号",
          "卡密",
          "价格",
          "门槛",
          "创建时间"
        ];
        const filterVal = [
          "couponTitle",
          "msg",
          "cardNumber",
          "password",
          "price",
          "maxPrice",
          "createTime"
        ];
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "卡券列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    /*  导入物流单号 */
    importExcel(file) {
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some(item => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          // console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 一项项导入数据
          dateXlx
            .map(item => {
              return {
                ...item
                // 物流单号: item?.["物流单号"] || null
              };
            })
            .forEach(item => {
              // console.log("item", item["物流单号"]);
              if (item["物流单号"] !== null) {
                console.log('item["物流单号"]', item["物流单号"]);
                updateSendState({
                  id: item.id,
                  logisticsNumber: item["物流单号"]
                }).then(() => {
                  // console.log(res);
                  this.getListData();
                });
              } else {
                this.$message.error("请检查表格数据是否完整");
              }
            });
        }
      });
    },

    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary"
          });
          const result = [];
          this.wb.SheetNames.forEach(sheetName => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    },

    // ===== 模版管理相关方法 =====
    /* Tab切换 */
    switchTab(tabName) {
      this.activeTab = tabName;
      if (tabName === "templateManage") {
        this.getTemplateList();
      }
    },

    /* 获取模版列表 */
    async getTemplateList() {
      this.templateLoading = true;
      try {
        const { data, code, count } = await selectTemplateApi({
          pageNumber: this.templateQuery.pageNumber,
          pageSize: this.templateQuery.pageSize,
          couponTitle: this.templateQuery.couponTitle,
          status: this.templateQuery.status
        });
        if (code === 200) {
          this.templateTableData = data || [];
          this.templateQuery.total = count || 0;

          // 查询绑定的商品名称
          await this.loadProductNames();
        }
      } catch (err) {
        console.error(err);
        this.$message.error("获取模版列表失败");
      } finally {
        this.templateLoading = false;
      }
    },

    /* 加载商品名称 */
    async loadProductNames() {
      // 收集所有需要查询的商品ID
      const allProductIds = new Set();
      this.templateTableData.forEach(row => {
        if (row.product_id) {
          row.product_id.split(",").forEach(id => {
            if (id.trim()) {
              allProductIds.add(id.trim());
            }
          });
        }
      });

      if (allProductIds.size === 0) return;

      try {
        // 批量查询商品信息（不分页，获取所有相关商品）
        const { data, code } = await selectGoods({
          pageNumber: 1,
          pageSize: 1000, // 足够大的数量
          productName: ""
        });

        if (code === 200 && data) {
          // 创建商品ID到名称的映射
          const productMap = {};
          data.forEach(product => {
            productMap[product.id] = product.productName;
          });

          // 为每个模版添加商品名称
          this.templateTableData.forEach(row => {
            if (row.product_id) {
              const productIds = row.product_id.split(",");
              const productNames = productIds
                .map(id => productMap[id.trim()] || `未知商品(${id})`)
                .filter(Boolean);
              row.productNames = productNames.join(",");
            }
          });
        }
      } catch (err) {
        console.error("查询商品名称失败", err);
      }
    },

    /* 模版分页 */
    handleTemplateCurrentChange(e) {
      this.templateQuery.pageNumber = e;
      this.getTemplateList();
    },

    handleTemplateSizeChange(e) {
      this.templateQuery.pageSize = e;
      this.getTemplateList();
    },

    /* 新增模版 */
    handleAddTemplate() {
      this.templateDialogTitle = "新增模版";
      this.templateForm = {
        couponTitle: "",
        msg: "",
        price: 0,
        maxPrice: 0,
        validTime: "30",
        status: 1,
        product_id: ""
      };
      this.selectedTemplateProducts = [];
      this.templateDialogVisible = true;
    },

    /* 编辑模版 */
    async handleEditTemplate(row) {
      this.templateDialogTitle = "编辑模版";
      this.templateForm = { ...row };

      // 解析绑定的商品
      this.selectedTemplateProducts = [];
      if (row.product_id) {
        const productIds = row.product_id.split(",").filter(id => id.trim());

        // 根据ID获取商品信息
        if (row.productNames) {
          const productNames = row.productNames.split(",");
          this.selectedTemplateProducts = productIds.map((id, index) => ({
            id: id.trim(),
            productName: productNames[index] || `商品${id}`
          }));
        } else {
          // 如果没有商品名称，尝试查询
          try {
            const { data, code } = await selectGoods({
              pageNumber: 1,
              pageSize: 1000,
              productName: ""
            });
            if (code === 200 && data) {
              const productMap = {};
              data.forEach(product => {
                productMap[product.id] = product.productName;
              });
              this.selectedTemplateProducts = productIds.map(id => ({
                id: id.trim(),
                productName: productMap[id.trim()] || `商品${id}`
              }));
            }
          } catch (err) {
            console.error("查询商品失败", err);
            this.selectedTemplateProducts = productIds.map(id => ({
              id: id.trim(),
              productName: `商品${id}`
            }));
          }
        }
      }

      this.templateDialogVisible = true;
    },

    /* 删除模版 */
    handleDeleteTemplate(row) {
      this.$confirm("此操作将永久删除该模版, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const { code } = await deleteTemplateApi({ id: row.id });
            if (code === 200) {
              this.$message.success("删除成功");
              this.getTemplateList();
            } else {
              this.$message.error("删除失败");
            }
          } catch (err) {
            console.error(err);
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },

    /* 保存模版 */
    async saveTemplate() {
      // 验证
      if (!this.templateForm.couponTitle) {
        return this.$message.error("请填写卡券名称");
      }
      if (!this.templateForm.msg) {
        return this.$message.error("请填写描述");
      }
      if (!this.templateForm.price && this.templateForm.price !== 0) {
        return this.$message.error("请填写优惠券价格");
      }
      if (!this.templateForm.maxPrice && this.templateForm.maxPrice !== 0) {
        return this.$message.error("请填写满多少可用");
      }
      // if (!this.templateForm.validTime) {
      //   return this.$message.error("请填写有效期");
      // }

      // 组装商品ID列表
      const product_id = this.selectedTemplateProducts.map(p => p.id).join(",");

      const params = {
        ...this.templateForm,
        product_id
      };

      this.templateLoading = true;
      try {
        let result;
        if (this.templateForm.id) {
          // 编辑
          result = await updateTemplateApi(params);
        } else {
          // 新增
          result = await addTemplateApi(params);
        }

        if (result.code === 200) {
          this.$message.success(this.templateForm.id ? "编辑成功" : "新增成功");
          this.templateDialogVisible = false;
          this.getTemplateList();
        } else {
          this.$message.error(result.message || "操作失败");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("操作失败");
      } finally {
        this.templateLoading = false;
      }
    },

    /* 显示模版商品选择器 */
    showTemplateProductSelector() {
      this.templateProductSelectorVisible = true;
      this.templateProductQuery = {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: ""
      };
      this.getTemplateProductList();
    },

    /* 获取模版商品列表 */
    async getTemplateProductList() {
      this.templateProductLoading = true;
      try {
        const { data, code, count } = await selectGoods({
          pageNumber: this.templateProductQuery.pageNumber,
          pageSize: this.templateProductQuery.pageSize,
          productName: this.templateProductQuery.productName
        });
        if (code === 200) {
          this.templateProductTableData = data || [];
          this.templateProductQuery.total = count || 0;
        }
      } catch (err) {
        console.error(err);
        this.$message.error("获取商品列表失败");
      } finally {
        this.templateProductLoading = false;
      }
    },

    /* 模版商品列表分页 */
    handleTemplateProductCurrentChange(e) {
      this.templateProductQuery.pageNumber = e;
      this.getTemplateProductList();
    },

    handleTemplateProductSizeChange(e) {
      this.templateProductQuery.pageSize = e;
      this.getTemplateProductList();
    },

    /* 模版商品选择 */
    handleTemplateProductSelect(row) {
      const index = this.selectedTemplateProducts.findIndex(
        p => p.id === row.id
      );
      if (index > -1) {
        // 已选择，取消选择
        this.selectedTemplateProducts.splice(index, 1);
        this.$message.success(`已取消选择: ${row.productName}`);
      } else {
        // 未选择，添加
        this.selectedTemplateProducts.push({
          id: row.id,
          productName: row.productName
        });
        this.$message.success(`已选择: ${row.productName}`);
      }
    },

    /* 判断商品是否已选择 */
    isProductSelected(productId) {
      return this.selectedTemplateProducts.some(p => p.id === productId);
    },

    /* 移除模版商品 */
    handleRemoveTemplateProduct(productId) {
      const index = this.selectedTemplateProducts.findIndex(
        p => p.id === productId
      );
      if (index > -1) {
        this.selectedTemplateProducts.splice(index, 1);
      }
    },

    /* 查看详情 */
    async handleDetails(row) {
      this.detailsData = { ...row };
      this.detailsProductNames = [];

      // 如果有关联商品，查询商品名称
      if (row.product_id) {
        const productIds = row.product_id
          .toString()
          .split(",")
          .filter(id => id.trim());
        if (productIds.length > 0) {
          try {
            const { data, code } = await selectGoods({
              pageNumber: 1,
              pageSize: 1000,
              productName: ""
            });
            if (code === 200 && data) {
              const productMap = {};
              data.forEach(product => {
                productMap[product.id] = product.productName;
              });
              this.detailsProductNames = productIds.map(id => ({
                id: id.trim(),
                name: productMap[id.trim()] || `未知商品(${id})`
              }));
            }
          } catch (err) {
            console.error("查询商品失败", err);
            this.detailsProductNames = productIds.map(id => ({
              id: id.trim(),
              name: `商品${id}`
            }));
          }
        }
      }

      this.detailsDialogVisible = true;
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  padding: 20px;
  width: 100%;

  /* 自定义 Tab 样式 */
  .custom-tabs {
    // background: #fff;
    // border: 1px solid #dcdfe6;
    // border-radius: 4px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

    .tab-header {
      display: flex;
      border-bottom: 2px solid #e4e7ed;
      background: #f5f7fa;

      .tab-item {
        padding: 15px 30px;
        cursor: pointer;
        position: relative;
        font-size: 14px;
        color: #303133;
        transition: all 0.3s;
        user-select: none;

        &:hover {
          color: #409eff;
        }

        &.active {
          color: #409eff;
          font-weight: 600;

          &::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: #409eff;
          }
        }

        span {
          display: inline-block;
        }
      }
    }

    .tab-content {
      padding: 0;
      min-height: 400px;
      overflow: auto;
    }
  }
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
.sku {
  border: 1px dotted rgb(189, 189, 189);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}
.sku > div {
  margin-right: 10px;
  padding: 10px 20px;
  background: rgb(245, 138, 44);
  border-radius: 10px;
  color: white;
}
.sku > div:hover {
  cursor: pointer;
}
.skuBg {
  background: rgb(254, 66, 3) !important;
}
.handleBtn {
  margin: 5px;
}
</style>
